// extracted by mini-css-extract-plugin
export default {"footer":"AccessChangeModal_footer__oPVEF","options":"AccessChangeModal_options__+HTEp"};